module.exports = __webpack_public_path__ + "img/160x41_Get_Flash_Player.ab5d6922.jpg";